import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../../context/AuthContext';
export const ProtectedRoute = () => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        // Retorna null ou um spinner simples enquanto carrega o estado de autenticação
        // Para evitar redirecionamento prematuro
        return null;
    }
    return isAuthenticated ? _jsx(Outlet, {}) : _jsx(Navigate, { to: "/login", state: { from: location }, replace: true });
};
//# sourceMappingURL=ProtectedRoute.js.map